export const SET_COMPONENT = "SET_COMPONENT";
export const STOP_LOADING = "STOP_LOADING";
